import { colors } from '../../Colors/colors'

export const crmItemDetailedViewTheme = {
   light: {
      common: {
         skeletonColor: '#F6F7F9', //TODO: Need to fix this
         skeletonBgColor: 'bg-gray-200',
         customOptionHoverBgColor: 'hover:bg-gray-50',
         selectedContactOptionBGColor: 'bg-gray-50',
         customOptionTextColor: 'text-gray-900',
         customOptionDisabledTextColor: 'text-gray-300',
         customOptionsDisabledBgColor: 'bg-gray-25',
         customOptionIconColor: colors['primary-600'],
         borderColor: 'border-gray-300',
         transparentBgColor: '!bg-[transparent]',
         closeIconFillColor: colors['gray-700'],
         buttonBgBlurHoverColor: 'hover:bg-[#00000025]',
         buttonBgBlurColor: 'bg-[#00000010]',
         toolTipBgColor: '!bg-gray-900',
         toolTipTextColor: 'text-base-white',
         defaultHoverBgColor: 'hover:bg-gray-50',
         openMapButtonTextColor: 'text-gray-700',
         linkIconColor: colors['gray-700'],
         closeIconColor: colors['gray-700']
      },
      stageTransitionConfirmationModal: {
         featureIcon: {
            outerBgColor: '#EFF8FF',
            innerBgColor: '#D1E9FF',
            fill: '#1570EF'
         },
         stageTransitionConfirmationCard: {
            backgroundColor: 'bg-base-white',
            boardHeading: 'text-gray-900',
            description: 'text-gray-600',
            closeIconColor: colors['gray-500']
         }
      },
      crmItemHeader: {
         pipelineNameTextColor: 'text-gray-600',
         nameTextColor: 'text-gray-900',
         pipelineItemNameColor: '!text-gray-800',
         phoneNumberTextColor: 'text-gray-600',
         emailTextColor: 'text-gray-600',
         stage: {
            customOptionHoverBgColor: 'hover:bg-gray-50',
            focusBgColor: 'bg-gray-50',
            selectedBgColor: 'bg-gray-50',
            tickIconColor: colors['primary-600']
         },
         copyLinkTextColor: 'text-primary-600',
         linkIconColor: colors['primary-600'],
         closeIconColor: colors['gray-500'],
         plusIconColor: colors['gray-600'],
         whatsAppButtonBgColor: 'bg-success-50',
         whatsAppButtonTextColor: 'text-success-600',
         borderColor: 'border-gray-300',
         backgroundColor: 'bg-base-white',
         alarmPlusIconColor: colors['violet-600'],
         whatsAppBgColor: 'bg-success-50',
         alarmBgColor: 'bg-violet-50'
      },
      applicationDetailedViewRightSidePane: {
         whiteBgColor: 'bg-white',
         blackBgColor: 'bg-black',
         whiteTextColor: 'text-white',
         transparentBgColor: 'bg-transparent',
         tabsBgColor: 'bg-black/5',
         tabBgColor: 'bg-gray-900',
         tabTextColor: 'text-gray-600',
         defaultBorderColor: 'border-gray-300',
         chevronIconColor: colors['gray-600'],
         messageIconColor: colors['base-white']
      },
      verticalBodyBorderColor: 'border-gray-300',
      stageOverViewFields: {
         headingTextColor: 'text-gray-700',
         cardBorderColor: 'border-gray-300',
         horizontalLineBgColor: 'bg-gray-200',
         fieldNameTextColor: 'text-gray-600',
         fieldValueTextColor: 'text-gray-800',
         phoneNumberTextColor: 'text-primary-600'
      },
      applicationPipelineOverViewFields: {
         headingTextColor: 'text-gray-700',
         horizontalLineBgColor: 'bg-gray-200',
         fieldNameTextColor: 'text-gray-500'
      },
      suggestedTasks: {
         cardHoverBgColor: 'bg-gray-50',
         taskTemplateNameColor: 'text-gray-700',
         cardBgColor: 'bg-base-white',
         arrowIconColor: colors['primary-600'],
         callStatusCard: {
            hoverBorderColor: 'hover:border-primary-600',
            selectedBoarderColor: 'border-primary-600',
            unSelectedBoarderColor: 'border-gray-300'
         },
         infoCircleIcon: colors['gray-600'],
         chevronRightIconColor: colors['gray-500'],
         otherFieldsBorderColor: 'border-gray-300',
         otherFieldsTextColor: 'text-gray-700',
         draftResponseInfoTextColor: 'text-gray-600',
         separatorBgColor: 'bg-gray-300',
         headingColor: 'text-gray-700'
      },
      suggestedTasksV2: {
         header: {
            cardBorderColor: 'border-gray-300',
            headingColor: 'text-gray-700',
            refreshIconColor: colors['gray-500'],
            savingText: 'text-gray-600',
            savedDraftTextColor: 'text-gray-700',
            alertCircleIconColor: colors['gray-700']
         },
         footer: {
            cardBorderColor: 'border-gray-300',
            errorTextColor: 'text-error-500'
         }
      },
      crmItemTab: {
         entityNameTextColor: 'text-gray-600'
      },
      tabs: {
         activeTabColor: colors['primary-600'],
         inactiveTabController: colors['gray-400'],
         borderColor: 'border-gray-300'
      },
      expandableFieldsCard: {
         cardTitleColor: 'text-gray-700',
         leftBorderColor: 'bg-primary-600',
         cardBgColor: 'bg-base-white',
         editButtonColor: 'text-primary-600',
         editIconColor: colors['primary-600'],
         chevronIconColor: colors['gray-500'],
         fieldNameColor: 'text-gray-600',
         fieldValueColor: 'text-gray-700',
         phoneNumberTextColor: 'text-primary-600',
         phoneNumberIconColor: colors['primary-600'],
         dateColor: 'text-gray-700',
         URLTextColor: 'text-primary-600',
         separatorBgColor: 'bg-gray-300',
         multiSelectHiddenItemsColor: 'text-gray-800',
         multiSelectFieldTextColor: 'text-gray-600',
         multiSelectFieldBorderColor: 'border-gray-300',
         skeletonFieldTextColor: '#F6F7F9', //TODO: Need to fix this
         dividerBgColor: 'bg-gray-300',
         defaultBorderColor: 'border-gray-300',
         anchorTextColor: 'text-primary-600',
         locationIconColor: colors['primary-600']
      },
      overviewCard: {
         headingTextColor: 'text-gray-700'
      },
      pipelineWiseStageAndDisplayStage: {
         pipelineNameColor: 'text-gray-700',
         cardBgColor: 'bg-base-white',
         separatorBgColor: 'bg-gray-300',
         headingColor: 'text-gray-700',
         labelColors: 'text-gray-500'
      },
      editButton: {
         buttonColor: 'text-primary-600',
         iconColor: colors['primary-600']
      },
      route: {
         bodyBackgroundColor: 'bg-gray-100'
      },
      remarks: {
         sidePaneHeader: {
            closeIconColor: colors['gray-500'],
            headerTextColor: 'text-gray-900',
            savedTextColor: 'text-gray-600',
            savedIconColor: colors['gray-500'],
            borderColor: 'border-gray-300',
            backLeftIconColor: colors['primary-600']
         },
         sidePane: {
            borderColor: 'border-gray-300',
            backgroundColor: 'bg-base-white'
         },
         remarkContentTextColor: 'text-gray-800',
         remarkCreatedDateTextColor: 'text-gray-600',
         remarkCardBgColor: 'bg-base-white',
         addRemark: {
            plusIconColor: colors['gray-600'],
            plusIconDisabledColor: colors['gray-300'],
            remarksTextColor: 'text-gray-600'
         },
         remarksReadOnly: {
            remarkBorderColor: 'border-gray-300',
            remarkHeadingTextColor: 'text-gray-500',
            remarkContentTextColor: 'text-gray-800'
         },
         remarksHeaderTextColor: 'text-gray-600',
         cardHoverBorderColor: 'hover:border-gray-300'
      },
      createdOnCard: {
         borderColor: 'border-gray-300',
         createdOnTextColor: 'text-gray-500',
         createdOnDateTimeColor: 'text-gray-800'
      },
      assigneeCard: {
         borderColor: 'border-gray-300',
         headingColor: 'text-gray-700',
         editIconColor: colors['primary-600'],
         cardBgColor: 'bg-base-white',
         hrLineColor: 'bg-gray-200'
      },
      completedTasks: {
         cardTitleColor: 'text-gray-900',
         cardDescriptionColor: 'text-gray-500',
         cardBgColor: 'bg-base-white',
         chevronIconColor: colors['gray-500'],
         remarkContentColor: 'text-gray-800',
         remarkTitleColor: 'text-gray-500',
         callPlayIconColor: colors['primary-600'],
         callPauseIconColor: colors['primary-600'],
         callLogHeadingColor: 'text-gray-700',
         callLogDateTimeColor: 'text-gray-500',
         cardBorderColor: 'border-gray-300',
         linkableCallLogsTextColor: 'text-gray-600'
      },
      contactLeads: {
         leadTitleTextColor: 'text-gray-600',
         rockerIconColor: colors['gray-700'],
         popoverBorderColor: 'border-gray-300',
         popoverBgColor: 'bg-base-white',
         xCloseIconColor: colors['gray-400'],
         hrLineColor: 'bg-gray-300',
         leadCard: {
            cardBgColor: 'bg-base-white',
            cardBorderColor: 'hover:border-gray-300',
            pipeLineTextColor: 'text-gray-600',
            noAssigneeAvatarBgColor: 'bg-gray-100',
            noAssigneeAvatarTextColor: 'text-gray-600'
         }
      },
      historyLogs: {
         historyLogCard: {
            dateTextColor: 'text-gray-600',
            logTypeTextColor: 'text-gray-500',
            dateTimeTextColor: 'text-gray-700',
            cardMsgTextColor: 'text-gray-700',
            fieldTextColor: 'text-gray-700',
            removeSpanTextColor: 'text-error-700',
            iconContainerBgColor: 'bg-gray-100',
            logChangedByTextColor: 'text-gray-500',
            leadCreatedBgColor: colors['primary-600'],
            assignedFieldBgColor: colors['green-light-600'],
            stageUpdatedBgColor: colors['fuchsia-600'],
            assigneeRemovedBgColor: colors['error-600'],
            assigneeUpdatedBgColor: colors['violet-600'],
            paymentRequestCreatedBgColor: colors['primary-600'],
            paymentCompletedBgColor: colors['success-600'],
            paymentFailedBgColor: colors['error-600'],
            paymentCardTextColor: 'text-gray-800',
            paymentDescriptionTextColor: 'text-gray-500',
            noDataTitleTextColor: 'text-gray-900',
            noDataDescriptionColor: 'text-gray-500',
            pipelineEventCreatedBgColor: colors['violet-600'],
            pipelineEventCreateDefaultTextColor: 'text-gray-700',
            pipelineCardBorderColor: 'border-gray-200',
            pipelineNameTextColor: 'text-gray-700',
            timeSpentLabelColor: 'text-gray-500',
            timeSpentTextColor: 'text-gray-700',
            clockFillColor: colors['cyan-500'],
            clockStrokeColor: colors['cyan-600'],
            userNameColor: 'text-gray-700',
            defaultBorderColor: 'border-gray-300'
         },
         pipelineEvent: {
            sidePaneHeaderTextColor: 'text-gray-900',
            closeIconFillColor: colors['gray-500'],
            borderColor: 'border-gray-300'
         },
         paymentBreakDownCard: {
            paymentBreakDownCardBgColor: 'bg-gray-50',
            viewFreeBreakdownTitleColor: 'text-gray-700',
            chevronIconColor: colors['gray-600'],
            categoryColor: 'text-gray-500',
            amountColor: 'text-gray-800'
         },
         stageTransitionHistoryDetailedView: {
            headerBorderColor: 'border-gray-300',
            primaryLabelColor: 'text-gray-500',
            textColor: 'text-gray-800',
            borderColor: 'border-gray-200',
            attachmentColor: 'text-primary-600',
            closeIconColor: colors['gray-500'],
            headerTextColor: 'text-gray-900',
            checkboxColor: colors['gray-300'],
            separatorColor: 'text-gray-200'
         }
      },
      deals: {
         dealCard: {
            cardBgColor: 'bg-base-white',
            cardBorderColor: 'hover:border-gray-300',
            titleTextColor: 'text-gray-800',
            dateTextColor: 'text-gray-500',
            pipelineTextColor: 'text-gray-600',
            noAssigneeBgColor: 'bg-gray-100',
            noAssigneeTextColor: 'tex-gray-600'
         },
         headerTextColor: 'text-gray-600',
         popoverBorderColor: 'border-gray-300',
         popoverBgColor: 'bg-base-white',
         sendNotificationTextColor: 'text-gray-600'
      },
      sidePaneHeader: {
         closeIconColor: colors['gray-500'],
         headerTextColor: 'text-gray-900',
         savedTextColor: 'text-gray-600',
         savedIconColor: colors['gray-500'],
         borderColor: 'border-gray-300'
      },
      activitySidePane: {
         horizontalLineBgColor: 'bg-gray-200',
         fieldNameTextColor: 'text-gray-500',
         fieldValueTextColor: 'text-gray-800',
         phoneNumberTextColor: 'text-primary-600'
      },
      callLogs: {
         addCallLog: {
            textColor: 'text-primary-600',
            borderColor: 'border-gray-300',
            iconBgColor: colors['primary-50'],
            iconColor: colors['primary-600']
         },
         callLog: {
            phoneCallIconBgColor: colors['green-50'],
            phoneCallIconColor: colors['green-600'],
            trashIconColor: colors['gray-600'],
            watchIconColor: colors['gray-500'],
            incomingCallLogIconBgColor: 'bg-green-50',
            incomingCallLogIconColor: colors['green-600'],
            outgoingCallLogIconBgColor: 'bg-primary-50',
            outgoingCallLogIconColor: colors['primary-600'],
            callLogMissedIconBgColor: 'bg-error-50'
         },
         linkableCallLogCard: {
            selectedIconColor: colors['primary-600'],
            borderColor: 'border-gray-300',
            selectedBorderColor: 'border-primary-600',
            hoveredBorderColor: 'hover:border-primary-300',
            circleIconHoverColor: 'border-primary-600',
            circleIconHoverBgColor: 'bg-primary-100',
            circleIconColor: 'border-gray-300'
         },
         noCallLogsView: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         },
         linkedCallLogs: {
            borderColor: 'border-gray-300',
            headerColor: 'text-gray-600',
            dividerColor: 'bg-gray-200',
            plusIconColor: colors['primary-600']
         },
         callLogCard: {
            containerBackgroundColor: 'bg-white',
            containerBorderColor: 'border-gray-300',
            audioPlayerContainerBorderColor: 'border-gray-300',
            headingTextColor: 'text-gray-700',
            dateTimeTextColor: 'text-gray-700',
            agentNameTextColor: 'text-gray-700',
            agentEmailTextColor: 'text-gray-600'
         },
         callLogsList: {
            backgroundColor: 'bg-white',
            headingTextColor: 'text-gray-600'
         }
      },

      reminders: {
         sidePaneHeader: {
            closeIconColor: colors['gray-500'],
            headerTextColor: 'text-gray-900',
            savedTextColor: 'text-gray-600',
            savedIconColor: colors['gray-500'],
            borderColor: 'border-gray-300',
            backLeftIconColor: colors['primary-600']
         }
      },
      pinCard: {
         cardBgColor: 'bg-base-white',
         borderColor: 'border-gray-300',
         pinIconColor: 'text-gray-600',
         titleColor: 'text-gray-600',
         tooltipBgColor: 'bg-gray-900'
      },
      gofsSidePane: {
         workflowIconColor: colors['base-white']
      },
      expandableRelationRecordCard: {
         titleColor: 'text-gray-700',
         secondaryTitleColor: 'text-gray-600',
         viewDetailsColor: 'text-primary-600',
         linkExternalColor: colors['gray-600'],
         popoverBorderColor: 'border-gray-200',
         trashIconColor: colors['error-600'],
         deleteTextColor: 'text-error-700',
         chevronIconColor: colors['gray-500'],
         popoverTriggerIconColor: colors['gray-700'],
         popoverTriggerHoverColor: 'hover:bg-gray-50',
         containerBorderColor: 'border-gray-300',
         badgeBorderColor: 'border-gray-200',
         badgeHoverColor: 'hover:bg-gray-50'
      },
      addRelationRecordCard: {
         cardBorderColor: 'border-gray-200',
         titleColor: 'text-gray-700',
         selectedTitleColor: 'text-primary-800',
         selectedCheckIconColor: colors['primary-600'],
         borderHoverColor: 'hover:border-primary-400',
         borderSelectedColor: 'border-primary-600',
         bgSelectedColor: 'bg-primary-50'
      },
      addRelationRecordSidePane: {
         footerBorderColor: 'border-gray-300',
         headerTitleColor: 'text-gray-900',
         headerDescriptionColor: 'text-gray-600',
         headerBorderColor: 'border-gray-300',
         closeIconColor: colors['gray-500'],
         searchIconColor: colors['gray-500'],
         plusIconColor: colors['gray-600']
      },
      relationRecordAccessDenied: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         avatarCardBgColor: 'bg-base-white',
         avatarCardBorderColor: 'border-gray-300',
         avatarTextColor: 'text-gray-700'
      },
      mergeRecords: {
         closeIconColor: colors['gray-400'],
         mergeRecordsInfo: {
            backButtonLeftIconFillColor: colors['primary-600'],
            bottomSectionBorderColor: 'border-gray-300',
            descriptionColor: 'text-gray-600',
            mergeRightIconFillColor: colors['primary-600'],
            recordDetailsContainerBorderColor: 'border-gray-300',
            recordNameTextColor: 'text-gray-900',
            recordTypeAvatarContainerBGColor: 'bg-gray-100',
            recordTypeIconFillColor: colors['gray-600'],
            titleColor: 'text-gray-700'
         },
         rightArrowIconColor: colors['base-white'],
         modelFooterBorderColor: 'border-gray-300',
         closeIconFillColor: colors['gray-500'],
         closeIconBGColor: '!bg-transparent',
         closeIconHoveredBGColor: `hover:!bg-gray-50`,
         mergeRecordsModalHeader: {
            title: 'text-gray-800',
            description: 'text-gray-600',
            headerBorderColor: `border-gray-300`
         },
         searchDuplicateRecord: {
            checkIconColor: colors['primary-600'],
            recordNameTextColor: 'text-gray-700',
            recordHoverColor: 'hover:bg-gray-50',
            recordSelectedColor: 'bg-gray-50'
         },
         conflictedRecords: {
            pipelineNameTextColor: 'text-gray-700',
            recordNameTextColor: 'text-gray-700',
            noAccessTitleColor: 'text-gray-700',
            noAccessDescriptionColor: 'text-gray-500',
            mergedTextColor: 'text-primary-600',
            borderColor: 'border-gray-300',
            mergedIconColor: colors['primary-600']
         },
         mergeFieldsTableStep: {
            defaultTextColor: 'text-gray-600',
            defaultBorderColor: 'border-gray-300',
            defaultBGColor: 'bg-gray-50',
            defaultHoveredBGColor: 'hover:bg-gray-50',
            transparentBGColor: '!bg-transparent',

            cellFocusRingDefaultColor: 'text-primary-300',
            cellFocusRingErrorColor: 'text-error-300',
            checkboxCheckedIconColor: colors['primary-600'],
            editedLabelTextColor: 'text-gray-400',
            identificationIconColor: colors['teal-600'],
            mainRecordBGColor: 'bg-primary-50',
            relationConflictsHeaderBGColor: 'bg-primary-50',
            tableCellIsSelectedBorderColor: 'border-primary-600',
            tableCellDisabledBGColor: 'bg-gray-100',
            tableBody: {
               overviewFieldDataTextColor: 'text-gray-600',
               overviewFieldDataBorderColor: 'border-gray-300',
               relatedRecordsTextColor: 'text-gray-800'
            },
            tableFooter: {
               arrowRightIconColor: colors['base-white'],
               arrowLeftIconColor: colors['primary-600'],
               footerBorderColor: 'border-gray-300'
            }
         },
         notifications: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            cardBorderColor: 'border-gray-100',
            mergeIconColor: colors['primary-600'],
            mergeIconInnerBGColor: colors['primary-100'],
            mergeIconOuterBGColor: colors['primary-50'],
            closeIconColor: colors['gray-500'],
            arrowIconColor: colors['primary-600']
         },
         mergeRecordSyncInProgress: {
            headerTextColor: 'text-gray-900',
            descriptionTextColor: 'text-gray-600',
            buttonIconFillColor: colors['base-white']
         }
      },
      whatsappIntegrations: {
         messageTemplates: {
            templateTextColor: 'text-gray-700',
            copyIconColor: colors['primary-600'],
            eyeIconColor: colors['primary-600'],
            cardBorderColor: 'border-gray-300',
            templateNameColor: 'text-gray-700',
            templateContentColor: 'text-gray-500',
            dividerBgColor: 'bg-gray-300'
         },
         selectedNumbers: {
            labelTextColor: 'text-gray-600',
            sectionCard: {
               sectionNameTextColor: 'text-gray-700',
               sectionDescriptionTextColor: 'text-gray-500',
               sectionCardBGColor: 'bg-primary-50',
               sectionCardBorderColor: 'border-primary-600',
               headerTextColor: 'text-gray-900',
               descriptionTextColor: 'text-gray-600',
               closeIconColor: colors['gray-500'],
               defaultBorderColor: 'border-gray-200',
               selectedSectionTextColor: 'text-primary-800',
               selectedSectionDescriptionTextColor: 'text-primary-700',
               selectedSectionRadioBorderColor: colors['primary-300'],
               selectedSectionRadioDotColor: colors['primary-600'],
               selectedSectionRadioBGColor: 'bg-primary-100',
               unSelectedSectionRadioBorderColor: colors['gray-300'],
               unSelectedSectionRadioBGColor: 'bg-gray-100'
            }
         }
      },
      relatedObjects: {
         header: {
            closeIconColor: colors['gray-700'],
            headerBorderColors: 'border-b-gray-300',
            refreshIconBg: '!bg-white'
         },
         tabIconColor: colors['gray-400']
      },
      customObjects: {
         defaultBorderColor: 'border-gray-300',
         fieldLabelColor: 'text-gray-500',
         cardBgColor: 'bg-base-white'
      },
      fileUploaderField: {
         borderColor: 'border-gray-300',
         labelColor: 'text-gray-700',
         errorMessageColor: 'text-error-500',
         errorMessageBorderColor: 'border-error-300'
      },
      relatedRecordsList: {
         recordNameTextColor: 'text-primary-600',
         popoverRecordNameTextColor: 'text-gray-900',
         tooltipBgColor: 'bg-gray-900'
      },
      completeFieldResponse: {
         defaultBorderColor: 'border-gray-300',
         cardBgColor: 'bg-base-white',
         titleColor: 'text-gray-600',
         bodyTextColor: 'text-gray-800'
      },
      addAnotherGOF: {
         actionBgColor: 'hover:bg-gray-50',
         removeActionTextColor: 'text-error-700',
         defaultActionTextColor: 'text-gray-900',
         defaultIconColor: colors['gray-500'],
         loaderColor: colors['gray-600'],
         removeIconColor: colors['error-600']
      },
      documentTemplateViewHistory: {
         defaultTextColor: 'text-gray-900',
         defaultBorerColor: 'border-gray-300',
         documentFileNameColor: 'text-gray-700',
         documentFileInfoTextColor: 'text-gray-500',
         timelineIconColor: 'bg-gray-500'
      },
      documents: {
         headingColor: 'text-gray-600',
         chevronDownIconColor: colors['gray-600'],
         documentTemplateNameColor: 'text-gray-600',
         separatorBgColor: 'text-gray-300',
         documentCardBorderColor: 'border-gray-300',
         documentDetailsColor: 'text-gray-600',
         buttonTextColor: 'text-gray-700',
         defaultBorderColor: 'border-gray-300',
         baseBgColor: 'bg-base-white',
         rejectedTagBgColor: 'bg-error-100',
         rejectedTagTextColor: 'text-error-600',
         rejectedTagBorderColor: 'border-error-600',
         rejectedCardBorderColor: 'border-error-300',
         rejectedCardBgColor: 'bg-error-50'
      },
      googleMapsView: {
         defaultIconColor: colors['gray-500'],
         disabledIconColor: colors['gray-300'],
         defaultBorderColor: 'border-gray-300',
         errorBorderColor: 'border-error-300',
         backgroundColor: 'bg-base-white',
         currentLocationBorderColor: 'border-base-white',
         currentLocationFillColor: 'bg-primary-600',
         currentLocationRadiusFillColor: 'bg-primary-400',
         labelColor: 'text-gray-700',
         errorMessageColor: 'text-error-500',
         clearIconColor: colors['error-600'],
         clearTextColor: 'text-error-600',
         titleTextColor: 'text-gray-900',
         degreesTextColor: 'text-gray-400',
         tooltipBgColor: 'bg-gray-900',
         inputDisabledBgColor: 'bg-gray-50',
         seeMoreTextColor: 'text-gray-600',
         coordinateValueTextColor: 'text-gray-500'
      },
      documentESign: {
         defaultBorderColor: 'border-gray-300',
         bgColor: 'bg-gray-50',
         titleColor: 'text-gray-900',
         labelColor: 'text-gray-700',
         descriptionColor: 'text-gray-500',
         errorMessageColor: 'text-error-500',
         signedByTextColor: 'text-gray-500',
         permissionWarningTextColor: 'text-warning-700',
         disabledFieldBgColor: 'bg-gray-50',
         documentTitleColor: 'text-gray-800',
         documentDescriptionColor: 'text-gray-700',
         pinTitleColor: 'text-gray-900',
         pinDescriptionColor: 'text-gray-600',
         successTitleColor: 'text-gray-700',
         successDescriptionColor: 'text-gray-700',
         signDocumentItemBgColor: 'bg-white',
         signDocumentItemBorderColor: 'border-gray-300',
         signDocumentItemNameColor: 'text-gray-700',
         signDocumentsListBgColor: 'bg-white',
         signDocumentsListTitleColor: 'text-gray-900',
         signDocumentsListBulletDotColor: 'bg-gray-700',
         signDocumentsListBulletTextColor: 'text-gray-700'
      },
      recordScoreBadge: {
         borderColor: 'border-gray-300',
         scoreTextColor: 'text-gray-600',
         scoreValueColor: 'text-gray-800',
         totalPossibleScoreColor: 'text-gray-700'
      },
      suggestedTasksSectionCard: {
         selectedCardBorderColor: 'border-primary-600',
         sectionNameTextColor: 'text-gray-700',
         cardBgColor: 'bg-base-white',
         cardContainerBgColor: 'bg-gray-100',
         errorDotFillColor: colors['error-500']
      },
      stageTransitionModal: {
         baseWhiteBgColor: 'bg-white',
         defaultHeaderTextColor: 'text-gray-800',
         defaultBorderColor: 'border-gray-300',
         defaultDescriptionTextColor: 'text-gray-500',
         defaultBgColor: 'bg-gray-100',
         defaultSeparatorColor: 'bg-gray-300',
         gofHeaderTextColor: 'text-gray-600',
         chevronButtonBgColor: 'bg-transparent',
         chevronButtonHoverBgColor: '!hover:bg-gray-50',
         chevronColor: colors['gray-500'],
         rightArrowIconColor: colors['gray-700'],
         tabSectionBgColor: 'bg-gray-100',
         sectionTextColor: 'text-gray-600',
         activeSectionTextColor: 'text-primary-600',
         selectedCardBorderColor: 'border-primary-600',
         cardBgColor: 'bg-base-white',
         errorDotFillColor: colors['error-500'],
         arrowColor: colors['base-white'],
         overallObservationBgColor: 'bg-gray-50',
         createNote: {
            titleColor: 'text-gray-900',
            defaultBorderColor: 'border-gray-300',
            errorTextColor: 'text-error-600'
         },
         fieldsTextColor: 'text-gray-600',
         textInputIconColor: colors['gray-500']
      },
      stageTransitions: {
         lineBgColor: 'bg-primary-600',
         headerTextColor: 'text-gray-700',
         defaultBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         noDataViewTheme: {
            textColor: 'text-gray-700',
            cardBgColor: 'bg-white',
            borderColor: 'border-gray-200'
         },
         lineSeparatorBgColor: 'bg-gray-300',
         defaultTextColor: 'text-gray-700',
         defaultListIconBgColor: 'bg-gray-700',

         actionSummaryModel: {
            whiteBgColor: 'bg-base-white',
            dividerColor: 'bg-gray-300',
            checkCircleIconColor: colors['success-600'],
            xCircleIconColor: colors['error-600'],
            successTextColor: 'text-success-600',
            errorTextColor: 'text-error-700',
            shortfallIconColor: colors['warning-600'],
            warningTextColor: 'text-warning-700',
            headerTextColor: 'text-gray-900',
            disabledHeaderTextColor: 'text-gray-700',
            defaultDescriptionTextColor: 'text-gray-700',
            actionHeaderDescriptionTextColor: 'text-gray-600'
         }
      },
      recordReview: {
         defaultBorderColor: 'border-gray-300',
         defaultBgCardColor: 'bg-base-white',
         sectionHeaderTitleColor: 'text-gray-900',
         sectionHeaderEnhancerBgColor: 'bg-primary-600',
         generateIconBgColor: 'bg-primary-50',
         hintLeftIconColor: colors['gray-500'],
         hitIconColor: 'text-gray-600'
      },
      createSiteInspection: {
         defaultBoarderColor: 'border-gray-300',
         headingColor: 'text-gray-700',
         descriptionColor: 'text-gray-500',
         createSitInspectionContainer: 'bg-white',
         calendarIcon: {
            bgPrimaryColor: 'bg-primary-100',
            bgSecondaryColor: 'border-primary-50',
            strokeColor: colors['primary-600']
         }
      },
      updateSiteInspection: {
         defaultBoarderColor: 'border-gray-300',
         dateColor: 'text-gray-700',
         descriptionColor: 'text-gray-500',
         updateSitInspectionContainer: 'bg-white'
      },
      requestVerification: {
         requestCardBgColor: 'bg-base-white',
         requestCardBorderColor: 'border-gray-300',
         hrLineColor: 'bg-gray-300',
         requestTitleColor: 'text-gray-700',
         leftBarColor: 'bg-primary-600',
         editableFieldsTextColor: 'text-gray-500',
         remarksLabelColor: 'text-gray-600',
         remarksTextColor: 'text-gray-700'
      },
      richTextEditorCard: {
         cardBgColor: 'bg-white',
         cardBorderColor: 'border-gray-300',
         titleColor: 'text-gray-700',
         labelTextColor: 'text-warning-800',
         requiredTextColor: 'text-error-600',
         editorBorderColor: 'border-warning-600',
         editorBgColor: 'bg-warning-25',
         modalBgColor: 'bg-white',
         overlayBgColor: 'bg-[rgba(52,_64,_84,_0.7)]'
      },
      lineDepartmentHistoryLogs: {
         cardBgColor: 'bg-base-white',
         cardBorderColor: 'border-gray-300',
         titleColor: 'text-gray-700',
         remarksLabelColor: 'text-gray-600',
         remarksTextColor: 'text-gray-700',
         metaTextColor: 'text-gray-500',
         timelineIconBgColor: 'bg-gray-500'
      },
      filePreview: {
         defaultBorderColor: 'border-gray-300',
         cardBgColor: 'bg-base-white',
         fieldNameTextColor: 'text-gray-500',
         primaryTextColor: 'text-gray-700',
         secondaryTextColor: 'text-gray-700',
         sectionHeaderEnhancerBgColor: 'bg-primary-600',
         sectionHeaderTitleColor: 'text-gray-900'
      },
      verificationTab: {
         verificationTabFields: {
            cardBgColor: 'bg-base-white',
            defaultBorderColor: 'border-gray-300',
            fieldLabelColor: 'text-gray-700',
            contextFieldsBgColor: 'bg-gray-50'
         },
         verificationTabDecisionCard: {
            baseWhiteBgColor: 'bg-white',
            disabledBgColor: 'bg-gray-50',
            defaultBorderColor: 'border-gray-300',
            defaultPrimaryTextColor: 'text-primary-600',
            headerTextColor: 'text-gray-900',
            defaultPrimaryBgColor: 'bg-primary-600',
            closeIconColor: colors['error-500'],
            shortfallIconColor: colors['orange-500'],
            labelColor: 'text-gray-700'
         },
         documentsVerificationTab: {
            baseBgColor: 'bg-base-white',
            defaultBorderColor: 'border-gray-300',
            defaultTextColor: 'text-gray-700',
            defaultPrimaryBgColor: 'bg-primary-600',
            recommendationTextColor: 'text-gray-800',
            defaultDescriptionTextColor: 'text-gray-500',
            primaryIconColor: colors['primary-600'],
            customOptionHoverBgColor: 'hover:bg-gray-50',
            selectedOptionBgColor: 'bg-gray-50',
            notSelectedOptionBgColor: 'bg-white',
            lineSeparatorBgColor: 'bg-gray-300',
            acceptedBorderColor: 'border-success-400',
            acceptedBgColor: 'bg-success-50',
            acceptedTextColor: 'text-success-700',
            rejectedBorderColor: 'border-error-400',
            rejectedBgColor: 'bg-error-50',
            rejectedTextColor: 'text-error-700',
            shortfallBorderColor: 'border-warning-400',
            shortfallBgColor: 'bg-warning-50',
            shortfallTextColor: 'text-warning-700',
            remarksNoteTextColor: 'text-gray-600',
            expandAllTextColor: 'text-gray-600',
            primaryBgColor: 'bg-primary-600',
            switchBgColor: '!bg-gray-300',
            fieldNameTextColor: 'text-gray-700',
            tabNameTextColor: 'text-gray-700',
            headerTextColor: 'text-gray-900',
            footerBgColor: 'bg-gray-100'
         },
         verificationLogsTable: {
            titleTextColor: 'text-gray-600'
         }
      },
      siteVerificationCompletedTasks: {
         titleColor: 'text-gray-600',
         dividerColors: 'bg-gray-300'
      },
      generateDocument: {
         successfullySent: 'text-success-600',
         checkCircleFillIconColor: colors['success-600']
      },
      siteInspectionTab: {
         tabNameColor: 'text-gray-700',
         dropdown: {
            fieldResponseBorderColor: 'border-gray-300',
            fieldResponseTextColor: 'text-gray-700',
            emptyFieldResponseTextColor: 'text-gray-400',
            emptyResponseIconColor: colors['gray-500'],
            customOptionHoverBgColor: 'hover:bg-gray-50',
            selectedCustomOptionBgColor: 'bg-gray-50',
            customOptionTextColor: 'text-gray-900',
            customOptionSelectedIconColor: colors['gray-500'],
            closeIconColor: colors['gray-500'],
            selectedOptionBorderColor: 'border-gray-300',
            selectedOptionTextColor: 'text-gray-700'
         },
         number: {
            responseTextColor: 'text-gray-700',
            placeholderTextColor: 'text-gray-400'
         },
         remarks: {
            errorMessageTextColor: 'text-error-500',
            textColor: 'text-warning-900',
            infoColor: colors['warning-900']
         }
      },
      verificationCompletedTasks: {
         titleColor: 'text-gray-600',
         dividerColors: 'bg-gray-300'
      },
      gisTabSidePane: {
         primaryLabelColor: 'text-gray-700',
         secondaryLabelColor: 'text-gray-500',
         closeIconColor: colors['gray-400'],
         defaultBorderColor: 'border-gray-300',
         defaultPrimaryBgColor: 'bg-primary-600',
         sidepaneBorderColor: 'border-gray-300'
      },
      detailedViewV2: {
         buttonTextColor: 'text-gray-700',
         buttonIconColor: colors['gray-600'],
         loaderColor: colors['gray-700'],
         stageTransitionButtonTextColor: 'text-gray-900',
         stageTransitionButtonDisabledTextColor: '!text-gray-500',
         borderColor: 'border-gray-300',
         hrLineColor: 'bg-gray-300',
         headerFields: {
            textColor: 'text-gray-700',
            iconColor: colors['primary-600'],
            toggleTextColor: 'text-primary-600',
            bgColor: 'bg-white'
         }
      },
      horizontalTabs: {
         defaultBorderColor: 'border-gray-300',
         selectedTabBgColor: 'bg-gray-900',
         normalTabBgColor: 'bg-transparent',
         selectedTabTextColor: 'text-white',
         normalTabTextColor: 'text-gray-600',
         hoverTabTextColor: 'hover:text-gray-700',
         hoverTabBgColor: 'hover:bg-[rgba(16,_24,_40,_0.10)]'
      },
      verticalTab: {
         whiteBgColor: 'bg-white',
         dotBgStyles: 'bg-gray-400',
         dotIconStyles: colors['gray-400'],
         selectedBlueBarBgStyles: 'bg-primary-600',
         selectedTabTextStyles: 'text-primary-700',
         normalTabTextStyles: 'text-gray-700',
         verticalDottedLineColor: colors['gray-300'],
         icon: {
            defaultColor: colors['gray-500'],
            selectedColor: colors['primary-600']
         }
      },
      taskTab: {
         defaultBorderColor: 'border-gray-300',
         headingColor: 'text-gray-700',
         descriptionColor: 'text-gray-500',
         cardBgColor: 'bg-base-white',
         infoCircleIconColor: colors['warning-700']
      },
      mapsModal: {
         defaultBorderColor: 'border-gray-300',
         dimensionPickerBgColor: 'bg-gray-100',
         baseWhiteBgColor: 'bg-base-white',
         activeTabTextColor: 'text-gray-700',
         inactiveTabTextColor: 'text-gray-500',
         transparentBgColor: 'bg-transparent'
      },
      remarksNote: {
         cardBorderColor: 'border-gray-300',
         cardBgColor: 'bg-base-white',
         infoIconColor: colors['gray-500'],
         noteTextColor: 'text-gray-500'
      },
      pickerFieldCustomOptions: {
         selectedIconColor: colors['primary-600'],
         optionColor: 'text-gray-900',
         containerHoverColor: 'hover:bg-gray-50'
      },
      proposalFlowTab: {
         timeTextColor: 'text-gray-900',
         clockFillColor: colors['cyan-500'],
         clockStrokeColor: colors['cyan-600'],
         defaultBorderColor: 'border-gray-300',
         designationLabelColor: 'text-gray-600',
         designationColor: 'text-gray-700',
         nameTextColor: 'text-gray-700',
         arrowColor: colors['gray-500'],
         whiteBgColor: 'bg-white',
         inTimeLabelColor: 'text-base-white',
         inTimeTextColor: 'text-base-white',
         rightArrowIconColor: colors['base-white'],
         downArrowIconColor: colors['gray-500'],
         infoCircleIconColor: colors['gray-500']
      },
      linkedApplications: {
         labelColor: 'text-gray-600',
         defaultIconColor: colors['gray-600'],
         popoverBorderColor: 'border-gray-200',
         countTextColor: 'text-gray-700',
         countBgColor: 'bg-gray-100',
         cardBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         titleColor: 'text-gray-900'
      },
      shortfallConfirmationModal: {
         cardBgColor: 'bg-base-white',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         shortLeftContainerBorderColor: 'border-orange-dark-300',
         shortfallLeftBgColor: 'bg-orange-dark-50',
         shortfallLeftTextColor: 'text-orange-dark-600',
         countTextColor: 'text-orange-dark-600'
      },
      checkpointsTab: {
         markerBgColor: 'bg-primary-600',
         whiteBgColor: 'bg-white',
         borderColor: 'border-gray-300',
         headerTitleColor: 'text-gray-700',
         conditionTextColor: 'text-gray-700',
         editIconColor: colors['gray-900'],
         deleteIconColor: colors['error-600'],
         cardHoverBgColor: 'bg-gray-50',
         primaryBorderColor: 'border-primary-600',
         checkpointsTabHeader: {
            titleColor: 'text-gray-700'
         },
         noDataViewTheme: {
            titleColor: 'text-gray-700',
            descriptionColor: 'text-gray-600'
         }
      },
      tdrRequest: {
         infoTextColor: 'text-gray-600',
         officerInputTextColor: 'text-gray-900',
         marketFieldsContainerBgColor: 'bg-gray-50',
         marketFieldsErrorBgColor: 'bg-error-50',
         marketFieldsSuccessBgColor: 'bg-success-50',
         marketFieldsEqualBgColor: 'bg-warning-50',
         marketValueTitleColor: 'text-gray-600',
         marketValueColor: 'text-gray-700',
         hrLineColor: 'bg-gray-300',
         externalLinkHrLineColor: 'bg-gray-400',
         calculatorTextColor: 'text-gray-600',
         calculatorIconColor: colors['gray-600'],
         squareYardsBorderColor: 'border-gray-300',
         cardBorderColor: 'border-gray-300',
         cardBgColor: 'bg-base-white',
         leftEnhancerBgColor: 'bg-primary-600',
         dividerBgColor: 'bg-gray-300',
         titleColor: 'text-gray-900',
         remarksCardBgColor: 'bg-gray-50',
         remarksTitleColor: 'text-gray-800',
         field: {
            labelColor: 'text-gray-600',
            primaryValueColor: 'text-gray-800',
            valueColor: 'text-gray-700',
            fieldCardBgColor: 'bg-gray-50',
            fieldBottomCardBgColor: 'bg-warning-50'
         }
      },
      quickReview: {
         idTextColor: 'text-gray-800'
      },
      variableBlocksList: {
         defaultBgColor: 'bg-base-white',
         headingTextColor: 'text-gray-600',
         defaultBorderColor: 'border-gray-300',
         baseBlackColor: 'text-base-black'
      },
      showCauseNoticeModal: {
         defaultBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         xCloseIconColor: colors['gray-700'],
         iconContainerBgColor: 'bg-gray-50'
      },
      relatedComplaintsTab: {
         headerTextColor: 'text-gray-700',
         complaintCardBorderColor: 'border-gray-300',
         complaintCardBgColor: 'bg-base-white',
         complaintCardTextColor: 'text-gray-700'
      },
      officerOnSite: {
         defaultBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         blueMarkerColor: 'bg-primary-600',
         headerTextColor: 'text-gray-700',
         separatorBgColor: 'bg-gray-300'
      },
      officerListTable: {
         headerCellTextColor: 'text-gray-500',
         borderColor: 'border-gray-300',
         bodyCellTextColor: 'text-gray-800'
      },
      advActions: {
         loaderColor: colors['gray-700'],
         buttonBgColor: 'bg-[#00000010]',
         buttonHoverBgColor: 'hover:bg-[#00000025]',
         buttonSkeletonLoaderBgColor: '#00000010',
         buttonSkeletonLoaderHighlightBgColor: '#00000025',
         buttonTextColor: 'text-gray-700'
      },
      copyColumn: {
         copyConfirmationCardBgColor: 'bg-base-white'
      },
      feeEngineTab: {
         baseBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         defaultTextColor: 'text-gray-700'
      },
      ocSiteInspectionGofCard: {
         baseWhiteBg: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         textColor: 'text-gray-700'
      },
      ocSiteInspectionGofModal: {
         baseWhiteBg: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         textColor: 'text-gray-700',
         descriptionColor: 'text-gray-500',
         footerBgColor: 'bg-gray-50'
      },
      oCSiteInspectionGOfs: {
         bgColor: 'bg-blue-50',
         borderColor: 'border-blue-300',
         hintTextColor: 'text-gray-700',
         numberColor: 'text-gary-900',
         defaultBorderColor: 'border-gray-300',
         textColor: 'text-gray-700',
         tableTitleColor: 'text-gray-800',
         descriptionColor: 'text-gray-600',
         unfilledFieldsCountTextColor: 'text-gray-800',
         unfilledFieldsCardColors: 'bg-gray-25 border-gray-500'
      },
      kmlFiles: {
         chevronIconColor: colors['gray-600'],
         kmlTitleColor: 'text-gray-600',
         kmlDescriptionColor: 'text-gray-600',
         uploadKMLFileTextColor: 'text-gray-700',
         uploadCloudIconColor: colors['gray-600'],
         radioIconColor: 'border-gray-300',
         selectedRadioFillColor: colors['primary-600'],
         selectedKMLCardBgColor: 'bg-primary-50',
         selectedKMLCardTextColor: 'text-primary-600',
         selectedKMLCardBorderColor: 'border-primary-600',
         deleteIconColor: colors['error-700'],
         fileNameTextColor: 'text-gray-700',
         blueMarkerBgColor: 'bg-primary-600',
         loaderColor: colors['primary-600']
      },
      shortfallPopover: {
         shortfallIconColor: colors['warning-500'],
         headingTextColor: 'text-gray-700',
         labelTextColor: 'text-warning-800',
         starTextColor: 'text-error-600',
         richTextBorderColor: 'border-warning-600',
         richTextBgColor: 'bg-warning-25',
         shortfallTooltipTextColor: 'text-base-white'
      },
      quickReviewContextFields: {
         defaultBorderColor: 'border-gray-300',
         dividerBgColor: 'bg-gray-200',
         defaultDividerColors: 'bg-gray-300 border-gray-300',
         defaultTextColor: 'text-gray-700',
         defaultIconColor: colors['primary-600'],
         redirectIconColor: colors['gray-600'],
         toggleIconColor: colors['gray-500'],
         loadingTextColor: 'text-gray-700',
         hoverColor: 'hover:bg-gray-50'
      },
      tdrPaymentsVerificationTab: {
         amountComparisonCard: {
            titleEnhancerBgColor: 'bg-primary-600',
            titleColor: 'text-gray-900',
            fieldLabelColor: 'text-gray-600',
            fieldValueColor: 'text-gray-700',
            success: {
               borderColor: 'border-success-300',
               bgColor: 'bg-success-50'
            },
            error: {
               borderColor: 'border-error-300',
               bgColor: 'bg-error-50'
            },
            warning: {
               borderColor: 'border-warning-300',
               bgColor: 'bg-warning-50'
            }
         },
         budgetHeadsTable: {
            borderColor: 'border-gray-300',
            bgColor: 'bg-base-white',
            headerTextColor: 'text-gray-900',
            toolTipBgColor: '!bg-gray-900'
         }
      },
      sanctionDetails: {
         container: {
            backgroundColor: 'bg-white',
            borderColor: 'border-gray-300'
         },
         header: {
            iconBgColor: 'bg-primary-100',
            iconColor: colors['primary-600'],
            backgroundColor: 'bg-gray-50',
            borderColor: 'border-gray-300',
            titleColor: 'text-gray-700',
            subtitleColor: 'text-gray-500'
         },
         section: {
            titleColor: 'text-gray-700',
            separatorColor: 'bg-gray-300'
         },
         fieldGroup: {
            backgroundColor: 'bg-gray-25',
            borderColor: 'border-gray-300'
         }
      },
      documentVerificationAssignee: {
         defaultHeaderColor: 'text-gray-900',
         defaultDescriptionColor: 'text-gray-500',
         defaultBorderColor: 'border-gray-300'
      },
      siteInspectionTaskJobStatus: {
         verifyAllProgressView: {
            container: {
               backgroundColor: 'bg-white',
               borderColor: 'border-gray-100'
            },
            header: {
               titleColor: 'text-gray-900',
               descriptionColor: 'text-gray-600'
            },
            progress: {
               statusTextColor: 'text-gray-600',
               percentageTextColor: 'text-gray-700'
            }
         },
         taskProgressView: {
            title: {
               textColor: 'text-gray-800'
            },
            description: {
               textColor: 'text-gray-600'
            }
         }
      },
      pipelineItemDocument: {
         closeIconFillColor: colors['base-white'],
         closeIconStrokeColor: colors['gray-600']
      },
      objectionTask: {
         defaultBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         defaultHeaderTextColor: 'text-gray-900',
         defaultDescriptionTextColor: 'text-gray-500',
         fieldResponseTextColor: 'text-gray-800',
         primaryBgColor: 'bg-primary-600',
         lineSeparatorBgColor: 'bg-gray-300',
         dateTimeTextColor: 'text-gray-600',
         tabHeaderTextColor: 'text-gray-800',
         errorVariantTextColor: 'text-error-800'
      },
      appealTab: {
         appealTaskTabHeader: {
            titleColor: 'text-gray-700'
         },
         appealAssociatedTaskCard: {
            defaultBgColor: 'bg-base-white',
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-700',
            chevronIconFillColor: colors['gray-500'],
            dividerBgColor: 'bg-gray-300'
         },
         appealRemark: {
            labelTextColor: 'text-warning-800',
            starTextColor: 'text-error-600',
            richTextBorderColor: 'border-warning-600',
            richTextBgColor: 'bg-warning-25',
            defaultBorderColor: 'border-gray-300',
            defaultBgCardColor: 'bg-base-white',
            sectionHeaderTitleColor: 'text-gray-900',
            sectionHeaderEnhancerBgColor: 'bg-primary-600',
            enhancerBgColor: 'bg-base-white',
            disabledTextColor: 'text-gray-400',
            disabledBgColor: 'bg-gray-50',
            disabledBorderColor: 'border-gray-300'
         }
      },
      intimationPreviewModal: {
         defaultIconColor: colors['base-white'],
         defaultBgColor: 'bg-white',
         footerBorderColor: 'border-gray-200',
         closeIconStrokeColor: colors['gray-600'],
         filePreviewFooter: {
            defaultBgColor: 'bg-gray-800',
            defaultTextColor: 'text-white'
         }
      },
      fieldUpdateLogs: {
         labelColor: 'text-gray-700',
         valueColor: 'text-gray-600'
      }
   },
   dark: {}
}
